/*eslint-disable*/

import lunr from 'lunr';
import Worker from '../workers/indexing.worker.js';
import store from '@Store';
import { CLAUSE_LIBRARY } from '@Constants/types';
import { LOG_TYPE, addLog } from './loggingService';

const worker = new Worker();

export const triggerIndexingWorker = flattenClauseGroups => {
    try {
        store.dispatch({
            type: CLAUSE_LIBRARY.INDEXING_CLAUSES_START
        });
        worker.postMessage(flattenClauseGroups);

        worker.onerror = function(event) {
            addLog(LOG_TYPE.ERROR, 'triggerIndexingWorker', event);

            store.dispatch({
                type: CLAUSE_LIBRARY.INDEXING_CLAUSES_FAILED,
                payload: event.message
            });
        };

        worker.onmessage = function(event) {
            let idx = JSON.parse(event.data);
            let fullIdx = lunr.Index.load(idx);

            store.dispatch({
                type: CLAUSE_LIBRARY.INDEXING_CLAUSES_SUCCESS,
                payload: fullIdx
            });
        };
    } catch (error) {
        addLog(LOG_TYPE.ERROR, 'triggerIndexingWorker', error);

        store.dispatch({
            type: CLAUSE_LIBRARY.INDEXING_CLAUSES_FAILED,
            payload: 'error Happen in triggerIndexingWorker'
        });
    }
};
